import request from '@/js/request';
import axios from 'axios';

// 获取新闻
export function getNav(data, params) {
    return request.apiService({
        url: 'menu.json',
        method: 'get',
        params: params || {}
    })
}

export function getNewsList(data, params) {
    return request.apiService({
        url: 'news/lst/' + data[0] + '/' + data[1] + '/index.json',
        method: 'get',
        params: params || {}
    })
}

export function getTimeChainList(data, params) {
    return request.apiServiceApi({
        url: '/interface/searchTest.php',
        method: 'get',
        params: params || {}
    })
}

export function getSearch(data, params) {
    return request.apiServiceApi({
        url: 'interface/search.php',
        method: 'get',
        params: params || {}
    })
}


// 登陆
//提交用户信息
export function login(params) {
    return request.apiServiceApi({
        url: `interface/login.php`,
        method: 'get',
        params: params || {}
    })
}

// 獲取圖片驗證
export function getImgCode(params) {
    return request.apiServiceApi({
        url: `interface/yzm.php`,
        method: 'get',
        params: params || {}
    })
}

// 发送验证码
export function sendCode(data, params) {
    if (data) {
        return request.apiServiceApi({
            url: `interface/send/send/app.php`,
            method: 'get',
            params: params || {}
        })
    } else {
        return request.apiServiceApi({
            url: `interface/sendMail/mail.php`,
            method: 'get',
            params: params || {}
        })
    }

}

// 注册
export function regist(params) {
    return request.apiServiceApi({
        url: `interface/regist.php`,
        method: 'get',
        params: params || {}
    })
}

export function deleteUser(params) {
    return request.apiServiceApi({
        url: `interface/del_user.php`,
        method: 'get',
        params: params || {}
    })
}

// 修改密碼
export function updatePassword(params) {
    return request.apiServiceApi({
        url: `interface/update-password.php`,
        method: 'get',
        params: params || {}
    })
}

// 爆料
export function breakNews(params, formData) {
    return request.apiServiceApi({
        url: `interface/add-breakingNews.php?userid=${params.userid}&title=${params.title}&user_contact=${params.user_contact}`,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        data: formData
    })
}

// 统计php
export function tongjiPhp(params) {
    return request.apiServiceApi({
        url: `https://www.hkcd.com.hk/api/interface/stat/column_visit.php`,
        method: 'post',
        params: params || {}
    })
}

// 每个栏目对应的广告channelId
export function getAdChannelId() {
    return request.apiServicePhp({
        url: ``,
        method: 'get'
    })
}


// WEBPACK FOOTER //
// ./src/list/js/api.js